import React from 'react';

const Footer = () => {
  return (
    <footer style={{
      width: '100%',
      padding: '20px 0',
      backgroundColor: '#f8f9fa', // 사이트 분위기에 맞춰 수정
      color: '#6c757d',
      textAlign: 'center',
      fontSize: '14px',
      borderTop: '1px solid #dee2e6',
      marginTop: 'auto' // 컨텐츠가 적어도 하단에 붙게 함
    }}>
      <div className="container">
        <p style={{ margin: 0 }}>
          &copy; {new Date().getFullYear()} <strong>neulsign</strong>. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;